import { type ReactNode } from 'react';
import T from 'i18n-react';

import type { VehicleLocation } from 'Pages/vehicles/helpers/vehicle.schema';
import { removeFromString } from 'Utilities/formatters';

export const COUNTRIES_ALLOWED_IN_LOCATION_TEXT = ['Northern Ireland'];
export const WORDS_NOT_ALLOWED_IN_AREA_FIELD = ['Council'];
export const EMPTY_LOCATION = T.translate('vehicleDetails.location.empty');
export const DISTANCE_UNIT = {
	plural: T.translate('vehicleDetails.location.distanceLegacy.unit.plural'),
	singular: T.translate('vehicleDetails.location.distanceLegacy.unit.singular'),
};

type LocationText = Pick<VehicleLocation['seller'], 'area' | 'country' | 'town'>;

const formatLocationText = ({ area, country, town }: LocationText) => {
	if (COUNTRIES_ALLOWED_IN_LOCATION_TEXT.includes(country)) {
		return `${town}, ${country}`;
	}
	if (area && town !== area) {
		return `${town}, ${removeFromString(area, WORDS_NOT_ALLOWED_IN_AREA_FIELD)}`;
	}
	return town;
};

export const getLocationText = (location: LocationText): ReturnType<typeof formatLocationText> | ReactNode => {
	if (!location.town) {
		return EMPTY_LOCATION;
	}
	return formatLocationText(location);
};
